module.exports = __webpack_public_path__ + "static/media/FBG.309141ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/shgn/footerLogos/desktop/FBG.svg
// module id = 109
// module chunks = 0